export default "### Could not request password reset\n\nSorry. Could not request password reset. Please try again later."